//import { Box } from "@react-three/drei";
import { useFrame } from '@react-three/fiber'
import { useKeyboardControls } from '@react-three/drei'
import { useRef, useState, useEffect } from 'react'
import { useRapier, RigidBody, BallCollider } from '@react-three/rapier'
import * as THREE from 'three'
import useGame from './stores/useGame.jsx'


export default function Player() {
    const [subscribeKeys, getKeys] = useKeyboardControls()
    const body = useRef()

    const { rapier, world } = useRapier()
    const [smoothedCameraPosition] = useState(() => new THREE.Vector3(10, 10, 10))
    const [smoothedCameraTarget] = useState(() => new THREE.Vector3())
    const start = useGame((state) => state.start)
    const end = useGame((state) => state.end)
    const restart = useGame((state) => state.restart)
    const blocksCount = useGame((state) => state.blocksCount)
    let contactTreasure = useGame((state) => state.contactTreasure)


    const jump = () => {

        const origin = body.current.translation()
        origin.y -= 0.31
        const direction = { x: 0, y: - 1, z: 0 }
        const ray = new rapier.Ray(origin, direction)
        const hit = world.castRay(ray, 10, true)

        if (hit.toi < 0.15) {
            body.current.applyImpulse({ x: 0, y: 3.5, z: 0 })
        }
    }

    const reset = () => {
        body.current.setTranslation({ x: 0, y: 1, z: 2 })
        body.current.setLinvel({ x: 0, y: 0, z: 0 })
        body.current.setAngvel({ x: 0, y: 0, z: 0 })
    }
    //const impulse = { x: 0.0, y: 0, z: 0 }

    useEffect(() => {
        const unsubscribeReset = useGame.subscribe(
            (state) => state.phase,
            (value) => {
                if (value === 'ready')
                    reset()
            }
        )

        const unsubscribeJump = subscribeKeys(
            (state) => state.jump,
            (value) => {
                if (value)
                    jump()
            }
        )

        const unsubscribeAny = subscribeKeys(
            () => {
                start()
            }
        )

        return () => {
            unsubscribeReset()
            unsubscribeJump()
            unsubscribeAny()
        }
    }, [])

    useFrame((state, delta) => {
        /**
         * Controls
         */
        const { forward, backward, leftward, rightward } = getKeys()

        const impulse = { x: 0, y: 0, z: 0 }
        const torque = { x: 0, y: 0, z: 0 }

        const impulseStrength = 1.6 * delta
        const torqueStrength = 2.0 * delta

        if (forward) {
            impulse.z -= impulseStrength
            torque.x -= torqueStrength
        }

        if (rightward) {
            impulse.x += impulseStrength
            torque.z -= torqueStrength
        }

        if (backward) {
            impulse.z += impulseStrength
            torque.x += torqueStrength
        }

        if (leftward) {
            impulse.x -= impulseStrength
            torque.z += torqueStrength

        }

        body.current.applyImpulse(impulse)
        body.current.applyTorqueImpulse(torque)

        /**
         * Camera
         */
        const bodyPosition = body.current.translation()

        const cameraPosition = new THREE.Vector3()
        cameraPosition.copy(bodyPosition)
        cameraPosition.x += -2.25
        cameraPosition.z += 20.25
        cameraPosition.y += 3.65

        const cameraTarget = new THREE.Vector3()
        cameraTarget.copy(bodyPosition)
        cameraTarget.y += 0.25

        smoothedCameraPosition.lerp(cameraPosition, 5 * delta)
        smoothedCameraTarget.lerp(cameraTarget, 5 * delta)
      //  state.camera.position.copy(smoothedCameraPosition)
   // state.camera.lookAt(smoothedCameraTarget)

        /**
        * Phases
        */
        if (contactTreasure === 1) {
            contactTreasure: 0
            end()
        }

        if (bodyPosition.y < - 10) {
            contactTreasure = 0
            restart()
        }
    })
    return <>
        {/* Player */}

        <RigidBody
            name='player'
            ref={body}
            canSleep={false}
            colliders={false}
            restitution={0.2}
            friction={5}
            linearDamping={0.5}
            angularDamping={0.5}
            position={[2, 5, 2]}
            onCollisionEnter={({ manifold, target, other }) => {
                /*  console.log(
                     "Collision at world position ",
                     manifold.solverContactPoint(0)
                 );
 
                 if (other.rigidBodyObject) {
                     console.log(
                         // this rigid body's Object3D
                         target.rigidBodyObject.name,
                         " collided with ",
                         // the other rigid body's Object3D
                         other.rigidBodyObject.name
                     ) */
                if (other.rigidBodyObject.name === 'treasure') {
                    contactTreasure = 1
                    console.log("name is treasure")
                };

            }
            }
            onCollisionExit={({ other }) => {

                if (other.rigidBodyObject.name === 'treasure') {
                    contactTreasure = 0
                    console.log("restart")
                };

            }
            }

        >
            <BallCollider args={[0.5]} position={[0, 0, 0]} />
            <mesh castShadow>
                <icosahedronGeometry args={[.5, 1]} />
                <meshStandardMaterial flatShading color="mediumpurple" />
            </mesh>
        </RigidBody>
    </>
}